import { Link } from "@/components/common/Link";
const industries = [{
  name: "Retail & Showrooms",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/retail_spaces_industrial.png"
}, {
  name: "Warehousing & Logistics",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/warehouse_logistics_facility.png"
}, {
  name: "Commercial Offices",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/corporate_office_interior.png"
}, {
  name: "Mixed-Use Developments",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/mixed_use_development_site.png"
}, {
  name: "Industrial Facilities",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/industrial_complex_construction.png"
}, {
  name: "Multi-Residential",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/modern_residential_building.png"
}, {
  name: "Hospitality & Leisure",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/hospitality_hotel_interior.png"
}, {
  name: "Civil & Infrastructure",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/infrastructure_civil_engineering.png"
}];
export default function IndustriesServed() {
  return <section data-section-id="225423" id="industries-we-service" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Industries We Serve
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto">
            Delivering high-performance property solutions across the built environment, tailored to the unique operational demands of every sector.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {industries.map((industry, i) => {
          return <Link key={industry.name} to="#" onClick={e => e.preventDefault()} data-index={i} className="group relative aspect-[4/5] flex flex-col items-center justify-center border border-border bg-background transition-all duration-300 ease-in-out hover:shadow-xl overflow-hidden">
                <img src={industry.image} alt={industry.name} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 scale-110 group-hover:scale-100" loading="lazy" data-wvc-srcset={`${industry.image}-wvc-srcset`} data-wvc-sizes={`${industry.image}-wvc-sizes`} />
                <div className="absolute inset-0 bg-transparent transition-colors duration-500" />
                <span className="relative z-10 font-default text-[10px] uppercase tracking-tighter font-extrabold text-white bg-secondary/90 px-4 py-2 transition-all duration-300 group-hover:bg-primary group-hover:scale-105 text-center mx-4">
                  {industry.name}
                </span>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}